import { useTranslation } from "@i18n/hooks";
import {
	SelectSingleAccountFieldProps,
	SelectSingleAccountFieldState,
} from "./select-single-account-field.types";
import { SelectComplexDataField } from "../../../components/select-complex-data-field";
import { SearchableAccountTable } from "../searchable-account-table";
import { formatAccountLabel } from "../searchable-account-table/searchable-account-table.types";

export const SelectSingleAccountField = ({ ...props }: SelectSingleAccountFieldProps) => {
	const { t } = useTranslation("common");
	const noAccountSelectedLabel = t("account.noAccountSelected");
	return (
		<SelectComplexDataField<SelectSingleAccountFieldState>
			valueBody={(data) => (
				<>
					{data ? formatAccountLabel(data.name, data.ownerEmail) : noAccountSelectedLabel}
				</>
			)}
			valuePlaceholder={noAccountSelectedLabel}
			actionButtonLabel={t("account.selectSingleAccount")}
			headerLabel={t("account.selectOneAccount")}
			{...props}
		>
			<SearchableAccountTable selection={props.fieldValue} onChange={props.updateField} />
		</SelectComplexDataField>
	);
};
